import { defineAsyncComponent } from 'vue';

export const LazyCollectionSelect = defineAsyncComponent(() => import('./components/Collection/CollectionSelect.vue'));
